// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","inner":"inner__NMw3c","main":"main__PfKU5","nav":"nav__ikPuw","logo":"logo__jPF5-","active":"active__r+Z6z"};